import React, { useEffect, useState } from "react";
import './OpalAttendanceSection.css';
import { Button } from "react-bootstrap";
import OpalDayProofModal from "./OpalDayProofModal/OpalDayProofModal";
import OpalMissedCallSessionsModal from "../../OpalMissedCallSessionsModal/OpalMissedCallSessionsModal";
import { getAll } from "../../../localDB";
import { useBaseProvider } from "../../../BaseManager/BaseManager";
import TauriImage from "../../TauriImage/TauriImage";
import { SyncStatusMap } from "../../../visualizations/visualizations";

const OpalAttendanceSection = ({ }) => {
    const [showProofModal, setShowProofModal] = useState(false);
    const [showMissedCall, setShowMissedCall] = useState(false);
    const [attendance, setAttendnace] = useState(null);
    const [isEndingDay, setIsEndingDay] = useState(false);
    const { isSync } = useBaseProvider();

    const handleDay = (att) => {
        setAttendnace(att);
        if (att?.TimeIn && att?.TimeOut) {
            setIsEndingDay(true);
        }
        // if (att?.TimeOut) {
        //     setShowMissedCall(true);
        // }
    };

    const formatTime = (val) => {
        const formattedTime = attendance ? new Date(val).toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "2-digit",
            hour12: true
        }) : "";

        return formattedTime;
    }

    useEffect(() => {
        const checkAttendance = async () => {
            try {
                const todayDate = new Date();
                todayDate.setHours(0, 0, 0, 0);

                const attendance = await getAll("Attendance");
                const todayAttendance = attendance
                    .filter(a => a.SyncStatus !== SyncStatusMap.done)
                    .find((a) => {
                        const timeInDate = new Date(a?.TimeIn);
                        timeInDate.setHours(0, 0, 0, 0); // normalize

                        return timeInDate.getTime() === todayDate.getTime();
                    });

                if (todayAttendance) {
                    setAttendnace(todayAttendance);
                }

            } catch (error) {
                console.log("Error getting the attendance!", error);
            }
        };

        checkAttendance();
    }, []);


    return (
        <div className="chart-content d-flex flex-colum">
            {attendance?.TimeIn && attendance?.TimeOut ? (
                <div className="opal-attendance d-flex align-items-center text-start h-100">
                    <div className="opal-attendance-container">
                        <TauriImage
                            localImage={"/Images/material-symbols--check-small.svg"}
                            color={"#049D33"}
                            className="att-img"
                        />
                        <div className="opal-attendance-times">
                            <div className="opal-attendance-row">
                                <span className="labelName">Started:</span>
                                <span className="value">{formatTime(attendance?.TimeIn)}</span>
                            </div>
                            <div className="opal-attendance-row">
                                <span className="labelName">Finished:</span>
                                <span className="value">{formatTime(attendance?.TimeOut)}</span>
                            </div>
                        </div>
                    </div>
                </div>
            ) : attendance?.TimeIn ? (
                <div className="d-flex align-items-center text-start h-100">
                    <span>Time Started:</span>{" "}
                    {formatTime(attendance?.TimeIn)}
                </div>
            ) : null}

            {!attendance?.TimeOut && (
                <Button
                    className="opal-button-attendance-start d-flex align-items-center justify-content-center mt-auto w-100 h-25"
                    onClick={() => setShowProofModal(true)}
                    disabled={isSync}
                >
                    {attendance?.TimeIn ? "End Day" : "Start Day"}
                </Button>
            )}

            <OpalDayProofModal
                show={showProofModal}
                onHide={() => setShowProofModal(false)}
                headerTitle={attendance?.TimeIn ? "End of Day" : "Start of Day"}
                onDay={handleDay}
                attendance={attendance}
            />

            <OpalMissedCallSessionsModal
                show={showMissedCall}
                onHide={() => setShowMissedCall(false)}
                endDay={isEndingDay}
            />
        </div>
    );

}

export default OpalAttendanceSection;